import { QuickAccessCard, QuickAccessItemProps } from './QuickAccessCard';

interface QuickAccessGridProps {
  items: QuickAccessItemProps[];
  variant?: 'vertical' | 'horizontal';
}

export const QuickAccessGrid = ({ items, variant = 'vertical' }: QuickAccessGridProps) => {
  const isVertical = variant === 'vertical';

  return (
    <div
      className={
        isVertical
          ? 'grid grid-cols-[repeat(auto-fill,minmax(279px,1fr))] gap-[26px] pb-2 pt-3'
          : 'grid grid-cols-[repeat(auto-fill,minmax(375px,1fr))] gap-[26px] pb-2 pt-3'
      }
    >
      {items.map((link, key) => (
        <QuickAccessCard
          key={key}
          item={link}
          variant={variant}
          className={'w-full'} // Card expands to fill the grid cell
        />
      ))}
    </div>
  );
};
